// 214 addendum 1 §12 [RULED 55–57] — A FIGURE AS THE SCREEN SHOWS IT, IN CENTS,
// ONE DEFINITION FOR BOTH PLANES.
//
// `fc` prints every amount with two decimals, half away from zero
// (src/utils.ts — fr-BE, the documents' rule). A sum a person checks by eye is
// taken over THOSE cents, never over the raw doubles: 213B §2 [RULED 39] made
// the time-entry strip's four left cards that sum (`shownCents` stood in
// src/components/CountersStrip.tsx), and Laurent's screen of 03/10 read the
// strip's « Facturé » 34 926,75 € against the Récapitulatif's 34 926,77 € —
// the same rows, one summed in cents and one summed raw and rounded once.
//
// Addendum 1 rules the matter's entry-basis « honoraires + frais » to be the
// strip's figure wherever it stands (§12), the margin and the effective margin
// to be computed from the lines the summary shows, to the cent (§11), and an
// activity's money to be the sum of its entries' Amount cells (§13). So the
// definition leaves the strip for a module BOTH planes read — the browser's
// strip and counter (CountersStrip.tsx) and the server's recap, costs line and
// activity line (server/src/lib/caseFinancials.js), the way clientMatters.mjs
// and successFee.mjs are shared. Pure, no React, no DOM.

/** The figure's cents as `fc` would print it: two decimals, half away from zero (the strip's expression, verbatim;
 *  a non-finite input stays non-finite, as a raw sum would — nothing is read as zero here). */
export function shownCents(x) {
  return Math.sign(x) * Math.round(Math.abs(x) * 100);
}

/** Σ of each item's shown cents, back in the currency unit — the sum a reader makes over the printed figures. */
export function sumShown(values) {
  let c = 0;
  for (const v of values) c += shownCents(v);
  return c / 100;
}

/** `a − b − c − …` over the shown figures, in the currency unit: a line computed from lines the screen shows. */
export function diffShown(a, ...subtrahends) {
  let c = shownCents(a);
  for (const s of subtrahends) c -= shownCents(s);
  return c / 100;
}
